import { render, staticRenderFns } from "./Comment.vue?vue&type=template&id=cb4bb05c&scoped=true"
import script from "./Comment.vue?vue&type=script&lang=js"
export * from "./Comment.vue?vue&type=script&lang=js"
import style0 from "./Comment.vue?vue&type=style&index=0&id=cb4bb05c&prod&lang=scss&scoped=true"
import style1 from "./Comment.vue?vue&type=style&index=1&id=cb4bb05c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb4bb05c",
  null
  
)

export default component.exports